import {Input} from 'antd'
import React from 'react'
import {NullAsDefault} from 'views/Shared'

export const NameInputField = ({name, value, prefix, onChange = NullAsDefault, ...props}) => {
  if (prefix) {
    return (
      <Input.Group style={{ display: 'flex', alignItems: 'center' }}>
        {prefix}
        <Input
            {...{name, value, onChange}}
            {...props}
            className="flex-1"
            style={{ borderRadius: 0 }}
        />
      </Input.Group>
    )
  } else {
    return (
      <Input
        {...{name, value, onChange}}
        {...props}
      />
    )
  }
}
